import { CButton, CFormInput, CFormLabel, CFormTextarea } from "@coreui/react";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import AxiosInstance from "src/components/Axios";
import { toast } from 'react-toastify'
import { useLoaderData, useNavigate } from "react-router-dom";


const urlApi = '/safety_measures_lists'
const urlRouter = '/safety_measures_lists'


export async function LoaderSafetyMeasuresListsUpdate({ params }) {
   console.log('LoadeWorkPlanUpdate params:', params)
   const id = params.pid

   if (Object.keys(params).length !== 0) {
      try {
         const response1 = await AxiosInstance.get(`${urlApi}/${id}`
            // , header
         )
         console.log('response1.data', response1.data)
         return { data: response1.data }
      } catch (error) {
         console.error('Помилка під час виконання запитів', error)
         return null
      }
   }
   return null
}




export default function WorkPlanSafetyMeasuresForm() {
   // хто увійшов
   const role = localStorage.getItem('user_role')
   // console.log(role)
   const { data } = useLoaderData() || []
   console.log('data', data)
   const [userId, setUserId] = useState(false)
   const [dataState, setDataState] = useState(data != undefined ? data : null)



   //для селекта
   const [stageTitle, setStageTitle] = useState('')

   //для нового заходу з ОП в інпуті
   const [stageInputText, setStageInputText] = useState(data !== undefined ? data.name : '')
   //для нового опису заходу з ОП в інпуті
   const [stageDescriptionText, setStageDescriptionText] = useState(data !== undefined ? data.description : '')
   //для оновлення селекта
   const [reloadKey, setReloadKey] = useState(0)
   const navigate = useNavigate()

   //стилі для селекту
   const customStyles = {
      menuList: (provided) => ({
         ...provided,
         maxHeight: '200px',
         overflowY: 'auto',
      }),
   };



   const loadOptions = async (inputValue = '') => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/safety_measures_lists?name=${inputValue}`
            // , header
         ).then((response) => {
            console.log('response.data', response.data)
            const options = response.data['hydra:member']?.map((result) => ({
               label: result.name,
               value: result.id,
            })
            );
            console.log('options', options)
            return options

         });
      } else {
         // if (userData.id) {
         //    return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`, header).then((response) => {
         //       return response.data.map((result) => ({
         //          label: result.name,
         //          value: result.id,
         //       }));
         //    });
         // }
         return []
      }
   }

   // функція для додавання заходу з ОП
   function addItem() {
      if (stageInputText === '' || stageDescriptionText === '') return

      const send_data = {
         name: stageInputText,
         description: stageDescriptionText
      }

      AxiosInstance.post(`/safety_measures_lists`, send_data
         // , header
      ).then((response) => {
         console.log('response.data', response.data)
         // return response.data.map((result) => ({
         //    label: result.name,
         //    value: result.id,
         // }));
         toast.success('Новий захід з ОП додано')
         setStageInputText('')
         setStageDescriptionText('')
         setReloadKey((prev) => prev + 1)

      }).catch(e => toast.error('Новий захід з ОП не додано'));

   }

   //функція для редагування заходу з ОП
   function updateItem() {
      if (stageInputText === '' || stageDescriptionText === '') return

      const send_data = {
         name: stageInputText,
         description: stageDescriptionText
      }
      console.log('send_data', send_data)

      AxiosInstance.put(`/safety_measures_lists/${dataState.id}`, send_data
         // , header
      ).then((response) => {
         console.log('response.data', response.data)
         toast.success('Тип роботи успішно змінено')
         // setStageInputText('')
         // setStageDescriptionText('')
         setDataState(response.data)
         setReloadKey((prev) => prev + 1)

      }).catch(e => toast.error('Захід з ОП не змінено'));

   }



   useEffect(() => {
      setStageInputText(dataState.name)
      setStageDescriptionText(dataState.description)

   }, [dataState])


   // console.log('loadOptions', loadOptions)
   console.log('dataState', dataState)

   if (role !== 'ROLE_ADMIN') { return }

   return (
      <>
         {/* Частина з реакт селектом заходів */}
         <div>
            <h2>Редагувати захід з ОП</h2>
            {/* <AsyncSelect
               key={reloadKey}
               cacheOptions
               loadOptions={loadOptions}
               defaultOptions
               // value={partnerFilterSearch}
               // onChange={handleChangePartner}
               className="flex-grow-1"
               placeholder="Этапи робіт"
               styles={customStyles}
            /> */}
         </div>
         {/* Частина для додавання нового типу до довідника з інпутом для назви */}
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput1">Введіть назву заходу з ОП</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput1"
               // defaultValue="Введіть назву нового заходу"
               value={stageInputText}
               onChange={(e) => setStageInputText(e.target.value)}
               placeholder="Введіть назву заходу з ОП"
               autoComplete="off"
            />
         </div>
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Введіть опис заходу з ОП</CFormLabel>
            <CFormTextarea
               type="text"
               id="exampleFormControlInput2"
               // defaultValue="Введіть опис нового етапу"
               value={stageDescriptionText}
               onChange={(e) => setStageDescriptionText(e.target.value)}
               placeholder="Введіть опис заходу з ОП"
               autoComplete="off"
            />
            <CButton
               className="mt-3"
               onClick={updateItem}
               disabled={stageInputText === dataState.name && stageDescriptionText === dataState.description}
            >Зберегти</CButton>
         </div>
      </>
   )
}